import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Payment", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Payment link created.", -1)
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Transaction was not successful:")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref } from "vue";
import BaseModal from "@/components/BaseModal.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  error: {
    type: String,
    required: false,
    default: null,
  },
  success: {
    type: Boolean,
    default: false,
  },
  paymentLink: {
    type: String,
    required: false,
    default: null,
  },
},
  emits: ["modalClosed"],
  setup(__props, { emit }) {

const props = __props

const successfulPayment = ref();


if (props.success && !props.error) {
  successfulPayment.value = true;
}
function close() {
  emit("modalClosed");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref: "modalRef",
    onModalClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('modalClosed')))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
      }, "x"),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["medium-width-centered", successfulPayment.value || __props.paymentLink ? 'success' : 'failed'])
      }, [
        (successfulPayment.value)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_2, "Transaction was successful!"))
          : (__props.paymentLink)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_3,
                _createElementVNode("a", {
                  class: "btn btn-blue payment-link-button",
                  href: __props.paymentLink,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, " Open Payment Link ", 8, _hoisted_4)
              ], 64))
            : (_openBlock(), _createElementBlock("h3", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(__props.error), 1)
              ]))
      ], 2)
    ]),
    _: 3
  }, 512))
}
}

})